import { apiClient } from './client'

export interface DashboardEmbeddingSecretItem {
  embeddingSecretId: string
  title: string | null
  workbookId: string | null
  createdBy: string | null
  createdAt: string | null
  updatedBy: string | null
  updatedAt: string | null
}

export interface DashboardEmbedItem {
  embedId: string
  title: string | null
  entryId: string | null
  embeddingSecretId: string | null
  depsIds: string[]
  unsignedParams: string[]
  privateParams: string[]
  publicParamsMode: boolean
  createdBy: string | null
  createdAt: string | null
  updatedBy: string | null
  updatedAt: string | null
}

export const fetchEmbeddingSecrets = async (workbookId: string): Promise<DashboardEmbeddingSecretItem[]> => {
  const response = await apiClient.get<DashboardEmbeddingSecretItem[]>('/dashboard-publications/embedding-secrets', {
    params: { workbook_id: workbookId },
  })
  return response.data
}

export const fetchEmbeds = async (entryId: string): Promise<DashboardEmbedItem[]> => {
  const response = await apiClient.get<DashboardEmbedItem[]>('/dashboard-publications/embeds', {
    params: { entry_id: entryId },
  })
  return response.data
}
